import { useState } from "react";
import Viewer3d from "../components/viewer3d.js";

import styles from "../styles/viewer3d.module.sass";
import OptionsPanel from "../components/optionsPanel.js";

export default function SmartObjectPlayer() {
  const [activeConfig, setActiveConfig] = useState(1);
  const [activeHinge, setActiveHinge] = useState(1);
  const [activeBugscreen, setActiveBugscreen] = useState(1);
  const [activeBlind, setActiveBlind] = useState(5);
  const [activeBlindDirection, setActiveBlindDirection] = useState(1);
  const [activePaintColor, setActivePaintColor] = useState(1);
  const [activePaintedSide, setActivePaintedSide] = useState(1);
  const [activePremiumCenterLock, setActivePremiumCenterLock] = useState(1);
  const [activeHardware, setActiveHardware] = useState(1);
  const [activeFrostedGlass, setActiveFrostedGlass] = useState(1);
  const [activeGrillStyle, setActiveGrillStyle] = useState(1);
  const [activeGrillPattern, setActiveGrillPattern] = useState(1);
  const [activeSDLStyle, setActiveSDLStyle] = useState(1);
  const [activeSDLPattern, setActiveSDLPattern] = useState(1);
  const [
    activeExtraScreenBlindCartridge,
    setActiveExtraScreenBlindCartridge,
  ] = useState(1);
  const [activeLimiter, setActiveLimiter] = useState(1);
  const [activeNightLock, setActiveNightLock] = useState(1);
  const [windowOpen, setWindowOpen] = useState(false);
  const [dayNightCycle, setDayNightCycle] = useState(false);
  const [interiorExterior, setInteriorExterior] = useState(false);
  return (
    <>
      <div className={styles.configurator}>
        <Viewer3d
        windowOpen={windowOpen}
        dayNightCycle={dayNightCycle}
        interiorExterior={interiorExterior}
        activeConfig={activeConfig}
        activeHinge={activeHinge}
        activeBugscreen={activeBugscreen}
        activeBlind={activeBlind}
        activeBlindDirection={activeBlindDirection}
        activePaintColor={activePaintColor}
        activePaintedSide={activePaintedSide}
        activePremiumCenterLock={activePremiumCenterLock}
        activeHardware={activeHardware}
        activeFrostedGlass={activeFrostedGlass}
        activeGrillStyle={activeGrillStyle}
        activeGrillPattern={activeGrillPattern}
        activeSDLStyle={activeSDLStyle}
        activeSDLPattern={activeSDLPattern}
        activeExtraScreenBlindCartridge={activeExtraScreenBlindCartridge}
        activeLimiter={activeLimiter}
        activeNightLock={activeNightLock}
        />
        <OptionsPanel
          windowOpen={windowOpen}
          setWindowOpen={setWindowOpen}
          dayNightCycle={dayNightCycle}
          setDayNightCycle={setDayNightCycle}
          interiorExterior={interiorExterior}
          setInteriorExterior={setInteriorExterior}
          activeConfig={activeConfig}
          setActiveConfig={setActiveConfig}
          activeHinge={activeHinge}
          setActiveHinge={setActiveHinge}
          activeBugscreen={activeBugscreen}
          setActiveBugscreen={setActiveBugscreen}
          activeBlind={activeBlind}
          setActiveBlind={setActiveBlind}
          activeBlindDirection={activeBlindDirection}
          setActiveBlindDirection={setActiveBlindDirection}
          activePaintColor={activePaintColor}
          setActivePaintColor={setActivePaintColor}
          activePaintedSide={activePaintedSide}
          setActivePaintedSide={setActivePaintedSide}
          activePremiumCenterLock={activePremiumCenterLock}
          setActivePremiumCenterLock={setActivePremiumCenterLock}
          activeHardware={activeHardware}
          setActiveHardware={setActiveHardware}
          activeFrostedGlass={activeFrostedGlass}
          setActiveFrostedGlass={setActiveFrostedGlass}
          activeGrillStyle={activeGrillStyle}
          setActiveGrillStyle={setActiveGrillStyle}
          activeGrillPattern={activeGrillPattern}
          setActiveGrillPattern={setActiveGrillPattern}
          activeSDLStyle={activeSDLStyle}
          setActiveSDLStyle={setActiveSDLStyle}
          activeSDLPattern={activeSDLPattern}
          setActiveSDLPattern={setActiveSDLPattern}
          activeExtraScreenBlindCartridge={activeExtraScreenBlindCartridge}
          setActiveExtraScreenBlindCartridge={
            setActiveExtraScreenBlindCartridge
          }
          activeLimiter={activeLimiter}
          setActiveLimiter={setActiveLimiter}
          activeNightLock={activeNightLock}
          setActiveNightLock={setActiveNightLock}
        />
      </div>
    </>
  );
}
